import styled, { css } from 'styled-components';

import { getFontStyle } from '~components/Text/helper';

interface ButtonProps {
  active?: boolean;
  year: 1 | 3 | 5;
}

export const Wrapper = styled.div`
  display: inline-flex;
  justify-content: center;
  overflow: hidden;
  margin-top: 40px;
`;

export const Button = styled.button<ButtonProps>`
  width: 80px;
  height: 32px;
  background: none;
  padding: 0;
  border-width: 0;
  ${getFontStyle('midium150_C1')};
  border: 1px solid ${({ theme }) => theme.colors.gray400};
  color: ${({ theme }) => theme.colors.gray900};
  cursor: pointer;

  &:first-child {
    border-radius: 16px 0px 0px 16px;

    ${({ year }) =>
      year === 3 &&
      css`
        border-right: 1px solid ${({ theme }) => theme.colors.magenta500};
      `}
  }

  &:nth-child(2) {
    border-left: none;
    border-right: none;
  }
  &:last-child {
    border-radius: 0px 16px 16px 0px;

    ${({ year }) =>
      year === 3 &&
      css`
        border-left: 1px solid ${({ theme }) => theme.colors.magenta500};
      `}
  }

  ${({ active, year }) =>
    active &&
    year === 1 &&
    css`
      border: 1px solid ${({ theme }) => theme.colors.magenta500};
      color: ${({ theme }) => theme.colors.magenta700};
    `}

  ${({ active, year }) =>
    active &&
    year === 5 &&
    css`
      border: 1px solid ${({ theme }) => theme.colors.magenta500};
      color: ${({ theme }) => theme.colors.magenta700};
    `}

    ${({ active, year }) =>
    active &&
    year === 3 &&
    css`
      border: 1px solid ${({ theme }) => theme.colors.magenta500};
      color: ${({ theme }) => theme.colors.magenta700};
    `}
`;
